import { render, staticRenderFns } from "./payfor-add.vue?vue&type=template&id=0facadd6&scoped=true&"
import script from "./payfor-add.vue?vue&type=script&lang=js&"
export * from "./payfor-add.vue?vue&type=script&lang=js&"
import style0 from "./payfor-add.vue?vue&type=style&index=0&id=0facadd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0facadd6",
  null
  
)

export default component.exports